"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

/**
 * ScrollToSection Component
 *
 * Handles automatic scrolling to sections based on URL hash
 * Example: navigating to "/#pricing" will scroll to the pricing section
 */
export function ScrollToSection() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Get hash from URL (e.g., #pricing)
    const hash = window.location.hash;

    if (hash) {
      // Remove the # symbol
      const sectionId = hash.substring(1);

      // Wait for the page to fully load
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    }
  }, [pathname, searchParams]);

  return null; // This component doesn't render anything
}
